import graphql__0f6dc46dee7bdd21aeef from "./__generated__/CityWalkTimelineWaypoint_waypoint.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch, useSelector } from "react-redux";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import Button from "../Buttons/Button";
import { useNavigateTo } from "../Routes/RoutesContext";
import { useMapContext } from "../Maps/MapContext";

import { setCityWalkCurrentWaypoint } from "../../reducers/cityWalks";
import { useFormatMessage } from "../Intl/Context";
import Icon from "../Utils/Icon";

const CityWalkTimelineWaypoint = props => {
  const waypoint = useFragment(CityWalkTimelineWaypoint_waypoint, props.waypoint);
  const { id: cityWalkWaypointId, indexLabel, isFilled } = waypoint;
  const { slug: participativeModuleSlug } = waypoint.cityWalk;

  const t = useFormatMessage();
  const filledSrOnlyLabel = t(intlMessages.filledSrOnlyLabel);

  const { mapKey } = useMapContext();

  const isActive = useSelector(({ map }) => {
    const { currentWaypoint } = map[mapKey].cityWalk;
    return currentWaypoint && currentWaypoint.id === cityWalkWaypointId;
  });

  const navigateTo = useNavigateTo();

  const dispatch = useDispatch();

  const handleButtonClicked = useCallback(() => {
    dispatch(setCityWalkCurrentWaypoint(mapKey, waypoint));
    navigateTo("cityWalkWaypoint", { participativeModuleSlug, cityWalkWaypointId });
  }, [
    participativeModuleSlug,
    cityWalkWaypointId,
    dispatch,
    mapKey,
    navigateTo,
    waypoint
  ]);

  const buttonClassName = classNames([
    "rounded-circle",
    "btn",
    {
      "btn-primary-inverse": !isActive,
      "btn-primary": isActive
    }
  ]);

  const fillingIconClassName = classNames([
    "city-walk-timeline-waypoint-filling-icon",
    {
      "bg-primary": isFilled,
      "text-white": isFilled,
      "fa fa-check": isFilled
    }
  ]);

  const ariaCurrentStep = isActive ? "step" : false;

  return (
    <li className="city-walk-timeline-waypoint">
      <Button
        className={buttonClassName}
        onClick={handleButtonClicked}
        aria-current={ariaCurrentStep}
      >
        {isFilled && (
          <>
            <Icon className={fillingIconClassName} />
            <span className="sr-only">{filledSrOnlyLabel}</span>
          </>
        )}
        {indexLabel}
      </Button>
    </li>
  );
};

const CityWalkTimelineWaypoint_waypoint = graphql__0f6dc46dee7bdd21aeef;

export default CityWalkTimelineWaypoint;

const intlMessages = defineMessages({
  filledSrOnlyLabel: {
    id: "cityWalk.timeline.waypoint.filledSrOnlyLabel",
    defaultMessage: "Étape de la balade renseignée"
  }
});
